module.exports = __webpack_public_path__ + "resources/image_fail_hor.60e25b3e0ca36bf2.png";